import { wrapReducer } from "@client/content/lib/helper";
import { type WithId } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type SetActiveTagActionData } from "./actions";
import { SHOW_ALL_TAG } from "./lib";

export type PortfolioGalleryAppState = WithId & {
  activeTagId: string;
  status: string;
};

const reducer = (state: PortfolioGalleryAppState, action: ReduxAction<any>): PortfolioGalleryAppState => {
  switch (action.type) {
    case Actions.SetActiveTag:
      const { tag } = action.data as SetActiveTagActionData;
      return {
        ...state,
        activeTagId: tag
      };
    default:
      return state;
  }
};

export const defaultState: PortfolioGalleryAppState = {
  id: "",
  activeTagId: SHOW_ALL_TAG.id,
  status: "Ready"
};
export const previewState = defaultState;
export default wrapReducer({ defaultState, reducer, previewState });
